import {
  Dimensions,
  FlatList,
  Image,
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  View,
  Modal,
  TouchableWithoutFeedback,
  Pressable,
} from "react-native";
import React from "react";
import {
  BatteryStatus,
  ModalDel,
  ParkstationAll,
  StationTop,
} from "../../../Constants/Data";
import AppColors from "../../../Constants/AppColors";
import AppFonts from "../../../Constants/AppFonts";
import AppImages from "../../../Constants/AppImages";
import Appstyles from "../../../Constants/AppStyles";
const { width, height } = Dimensions.get("window");
const StationTopTab = () => {
  const [DotModal, setDotModal] = React.useState(false);
  const [Modalvisible1, setModalvisible1] = React.useState(false);
  const [selectedItem, setSelectedItem] = React.useState(null);
  const [selectedButton, setSelectedButton] = React.useState(1);

  const handleBoxPressbtn = (item) => {
    setSelectedButton(item);
  };
  const [searchText, setSearchText] = React.useState("");

  return (
    <View style={Appstyles.backgrnd7}>
      <View style={Appstyles.viewofview7}>
        <View style={Appstyles.Searchvi6}>
          <TextInput
            style={Appstyles.TextInputr7}
            placeholder="Search Station Name, code, Address..."
            placeholderTextColor={"#AAAAAA"}
            editable={true}
            // value={searchText}

            autoCapitalize="none"
            // onChangeText={(text) => setsearchText(text)}
          />
          <View style={Appstyles.SearchImageView}>
            <Image source={AppImages.search} style={Appstyles.SearchImage} />
          </View>
        </View>

        <Image
          source={AppImages.Import}
          style={Appstyles.ImpoShare7}
          resizeMode="contain"
        />

        <Image
          source={AppImages.Shareit}
          style={Appstyles.ImpoShare7}
          resizeMode="contain"
        />
      </View>
      <View style={{}}>
        <FlatList
          data={StationTop}
          ListFooterComponent={() => <View style={{ padding: 85 }} />}
          renderItem={({ item }) => (
            <TouchableOpacity
              style={{
                backgroundColor:
                  selectedItem === item ? AppColors.sandal : AppColors.white,
                marginHorizontal: 20,
                borderRadius: selectedItem === item ? 10 : 5,
                borderWidth: selectedItem === item ? 0.5 : 0.5,
                marginBottom: 20,
                paddingVertical: 5,

                borderColor:
                  selectedItem === item ? AppColors.sandal : AppColors.brown,
              }}
              onPress={() => setSelectedItem(item)}
            >
              <View
                style={{ marginHorizontal: 20, marginTop: 5, marginBottom: 5 }}
              >
                <View style={{ flexDirection: "row" }}>
                  <Text
                    style={{
                      width: "60%",
                      fontFamily: AppFonts.OverpassRegular,
                      fontSize: 12,
                      color: AppColors.dualbrown,
                    }}
                  >
                    Station Name
                  </Text>
                  <Text
                    style={{
                      fontFamily: AppFonts.OverpassRegular,
                      fontSize: 12,
                      color: AppColors.dualbrown,
                    }}
                  >
                    Station Code
                  </Text>
                </View>

                <View style={{}}>
                  <View style={{ flexDirection: "row" }}>
                    <Text
                      style={{
                        width: "60%",
                        fontFamily: AppFonts.OverpassSemiBold,
                        fontSize: 14,
                        color: AppColors.brown,
                      }}
                    >
                      {item.RedbytesParking}
                    </Text>
                    <Text
                      style={{
                        fontFamily: AppFonts.OverpassSemiBold,
                        fontSize: 14,
                        color: AppColors.brown,
                      }}
                    >
                      {item.Test12345}
                    </Text>
                  </View>
                </View>
                <View style={{ flexDirection: "row", marginTop: 10 }}>
                  <Text
                    style={{
                      width: "60%",
                      fontFamily: AppFonts.OverpassRegular,
                      fontSize: 12,
                      color: AppColors.dualbrown,
                    }}
                  >
                    Parking Capacity
                  </Text>
                </View>

                <View style={{}}>
                  <View style={{ flexDirection: "row" }}>
                    <Text
                      style={{
                        width: "60%",
                        fontFamily: AppFonts.OverpassSemiBold,
                        fontSize: 14,
                        color: AppColors.brown,
                      }}
                    >
                      {item.ParkingCapacity}
                    </Text>
                  </View>
                </View>
              </View>
            </TouchableOpacity>
          )}
          keyExtractor={(item) => item.id.toString()} // Assuming each item has a unique id property
          extraData={selectedItem} // Update when the selectedItem changes
          // onPress={() => setSelectedItem(item)}
        />
      </View>
      <Modal
        animationType="slide"
        visible={DotModal}
        onRequestClose={() => {
          setDotModal(false);
        }}
        transparent={true}
      >
        <Pressable style={{ flex: 1, backgroundColor: AppColors.ModalColor }}>
          <View style={styles.viww}>
            <TouchableOpacity style={styles.hsh}>
              <Image source={AppImages.LineBar} style={styles.jns} />
            </TouchableOpacity>

            <TouchableOpacity
              style={{
                marginTop: 20,
                flexDirection: "row",
              }}
              onPress={() => setDotModal(false)}
            >
              <View style={styles.yooo}>
                <Text style={styles.ttxt}>View</Text>
              </View>
            </TouchableOpacity>
            <TouchableOpacity
              style={styles.fffsf}
              onPress={() => setDotModal(false)}
            >
              <View style={styles.yooo}>
                <Text style={styles.ttxt}>Edit</Text>
              </View>
            </TouchableOpacity>
            <TouchableOpacity
              style={styles.fffsf}
              onPress={() => [setDotModal(false), setModalvisible1(true)]}
            >
              <View style={styles.yooo}>
                <Text style={styles.modo}>Delete</Text>
              </View>
            </TouchableOpacity>
          </View>
        </Pressable>
      </Modal>

      {/* //-----------DeleteModal------// */}

      <Modal
        animationType="slide"
        transparent={true}
        visible={Modalvisible1}
        onRequestClose={() => {
          setModalvisible1(!Modalvisible1);
        }}
      >
        <Pressable
          onPress={() => setModalvisible1(false)}
          style={styles.presse}
        >
          <View style={styles.dsdd}>
            <View style={styles.sss}>
              <View style={styles.fd}>
                <View style={{}}>
                  <Text style={styles.hbh}>fffdfdsf</Text>
                </View>
              </View>
              <TouchableOpacity
                onPress={() => {
                  setModalvisible1(false);
                }}
              >
                <Image
                  source={AppImages.cross}
                  style={styles.hhsj}
                  resizeMode="contain"
                />
              </TouchableOpacity>
            </View>

            <View style={styles.lins}></View>
            <View style={styles.fasfd}>
              <Text style={styles.sdsds}>ffefeff</Text>
            </View>

            <View style={styles.mmm}>
              <View style={styles.hox}>
                {ModalDel.map((item, index) => (
                  <View
                    onPress={() => handleBoxPressbtn(item)}
                    style={styles.presss}
                  >
                    {selectedButton === index ? (
                      <TouchableOpacity
                        onPress={() => [
                          // handleBoxPressbtn(item),
                          setModalvisible1(false),
                        ]}
                      >
                        <View style={{}}>
                          <View
                            style={[
                              styles.LoginWithOtpVw,
                              {
                                backgroundColor:
                                  selectedButton === index
                                    ? AppColors.brown
                                    : AppColors.C4900C,
                              },
                            ]}
                          >
                            <Text
                              style={[
                                styles.RegisterTxt,
                                {
                                  color:
                                    selectedButton === index
                                      ? AppColors.white
                                      : AppColors.C4900CC,
                                },
                              ]}
                            >
                              {item.label}
                            </Text>
                          </View>
                        </View>
                      </TouchableOpacity>
                    ) : (
                      <TouchableOpacity
                        onPress={() => [
                          // handleBoxPressbtn(item),
                          setModalvisible1(false),
                        ]}
                      >
                        <View style={{}}>
                          <View style={{}}>
                            <View
                              style={[
                                styles.LoginWithOtpVw,
                                {
                                  backgroundColor:
                                    selectedButton === index
                                      ? AppColors.brown
                                      : AppColors.C4900C,
                                },
                              ]}
                            >
                              <Text
                                style={[
                                  styles.RegisterTxt,
                                  {
                                    color:
                                      selectedButton === index
                                        ? AppColors.white
                                        : AppColors.C4900CC,
                                  },
                                ]}
                              >
                                {item.label}
                              </Text>
                            </View>
                          </View>
                        </View>
                      </TouchableOpacity>
                    )}
                  </View>
                ))}
              </View>
            </View>
          </View>
        </Pressable>
      </Modal>
    </View>
  );
};

export default StationTopTab;

const styles = StyleSheet.create({
  ims: { width: 22, height: 22 },
  ha: { width: 22, height: 22 },

  feed: { backgroundColor: AppColors.ModalColor, flex: 1 },
  viww: {
    width: "100%",
    backgroundColor: "white",

    borderTopRightRadius: 16,
    borderTopLeftRadius: 16,
    position: "absolute",
    bottom: 0,
    padding: 20,
  },
  hsh: { justifyContent: "center", alignItems: "center" },
  jns: { width: "15%", height: 2 },
  yooo: {
    alignItems: "center",
    justifyContent: "center",
    marginLeft: 10,
  },
  ttxt: {
    fontFamily: AppFonts.OverpassRegular,

    fontSize: 14,
    color: AppColors.brown1,
  },
  fffsf: {
    marginTop: 20,
    flexDirection: "row",
  },
  modo: {
    fontFamily: AppFonts.OverpassRegular,

    fontSize: 16,
    color: AppColors.brown1,
  },
  presse: {
    flex: 1,
    backgroundColor: AppColors.BLUR_BG,
    alignItems: "center",
    justifyContent: "center",
  },
  dsdd: {
    backgroundColor: "white",
    borderRadius: 20,
    marginHorizontal: 20,
    width: "80%",
    paddingTop: 15,
  },
  sss: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginHorizontal: 20,
  },
  fd: { flexDirection: "row", alignItems: "center" },
  hbh: {
    fontFamily: AppFonts.OverpassRegular,
    fontSize: 20,
    lineheight: 25.32,
    color: AppColors.brown1,
  },
  hhsj: { width: 24, height: 24 },
  fasfd: { marginTop: 20, marginHorizontal: 20 },
  sdsds: {
    fontFamily: AppFonts.OverpassRegular,
    fontSize: 14,
    lineheight: 17.72,
    color: AppColors.brown1,
  },
  mmm: {
    flexDirection: "row",
    alignSelf: "flex-end",

    marginHorizontal: 20,
  },
  toda: { marginTop: 20, flexDirection: "row" },
});
